// Libs
import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

// Hooks
import useUser from '../../../hooks/useUser';
import useUI from '../../../hooks/useUI';

import { useStyles } from './SubnavigationBarStyles';

const TABS_SPACING_TABLET = 1.5;
const TABS_SPACING = 2.5;

const SubnavigationTab = ({ item, isActive, setActiveItem }) => {
  const { isDesktopMode } = useUI();
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ isKiteUser, isActive });
  return (
    <Chip
      size={isDesktopMode ? 'small' : 'medium'}
      label={item.label}
      onClick={() =>
        isActive ? setActiveItem(null) : setActiveItem(item.label)
      }
      className={classes.tab}
    />
  );
};

const SubnavigationBar = (props) => {
  const { classes } = useStyles();
  const { items, activeItem, setActiveItem } = props;
  const { isTabletMode } = useUI();

  return (
    <Stack
      direction="row"
      spacing={isTabletMode ? TABS_SPACING_TABLET : TABS_SPACING}
      className={classes.tabs}>
      {items.map((item) => (
        <SubnavigationTab
          key={item.key}
          item={item}
          isActive={item.label === activeItem}
          setActiveItem={setActiveItem}
        />
      ))}
    </Stack>
  );
};

export default SubnavigationBar;
